// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__dsgqf","modal":"modal_modal__Lzr+6"};